import React from "react";
import WidgetCard from "../widget/card";
import { Button } from "@ts-digital/vrc";
import { useSelector } from "react-redux";
import { TSDIGITAL_PORTALE_PUBLIC_URL } from "../../config.js";
import { FormattedMessage } from "react-intl";
import "./style.css";
import { Tooltip } from "antd";
import ImgTSPay from "../../assets/img/ts-pay.png";
import ImgCheckupImpresa from "../../assets/img/checkUp_Impresa.png";
import ImgIncassaSubito from "../../assets/img/incassa_Subito.png";
import ImgDigitalInvoice from "../../assets/img/digital_Invoice.png";

const WidgetTools = () => {
  const main = useSelector(state => state.main);
  const services = useSelector(state => state.servicesAgyo);
  const accountantIdSelected = main?.accountantIdSelected;

  const renderFooter = () => {
    const link =
      TSDIGITAL_PORTALE_PUBLIC_URL + "#/" + accountantIdSelected + "/dashboard";
    return (
      <span className="activeOthersTools" onClick={() => {
        if (window.aptrinsic) {
          window.aptrinsic("track", "digital-box:SC-STRUMENTI");
        }
      }}>
        <a href={link}
          target="_blank"
          rel="noopener noreferrer">
          <FormattedMessage id="widgetTools.active" /></a>
      </span>
    );
  };

  // metodo per dividere un array in sotto-array di lunghezza prestabilita
  const arrayChunks = (array, chunk_size) => {
    return Array(Math.ceil(array.length / chunk_size)).fill()
      .map((_, index) => index * chunk_size)
      .map(begin => array.slice(begin, begin + chunk_size));
  };

  // render dei servizi
  const renderServices = (
    activeTools, all, turnedOffTools
  ) => {
    // Elimino i duplicati dai servizi non attivi
    let turnedOffToolsUnique = turnedOffTools.filter((
      v, i, a
    ) => a.indexOf(v) === i);
    // Mostro tutti i servizi attivi, se però il numero di servizi attivi è minore di 8, mostro gli attivi più alcuni inattivi (max 8 elementi in questo caso)
    const maxLength = 4 - Object.keys(activeTools).length;
    let labelActive = Object.keys(activeTools);
    // Devo recuperare i sottoservizi attivi e quelli non attivi per farli vedere nel tooltip del servizio "padre"

    let badges = labelActive.map((el, keyIdx) => {
      let tooltipLabelActive = activeTools[el].map(service => {
        return <div key={service} className="divTools_tooltip">
          <div className="badgeTools active" />
          <span className="labelActiveService tooltip">{service}</span>
        </div>;
      });
      let tooltipLabelInactive = all[el].map(service2 => {
        if (!activeTools[el].includes(service2)) {
          return <div key={service2} className="divTools_tooltip">
            <div className="badgeTools off" />
            <span className="labelActiveService tooltip">{service2}</span>
          </div>;
        } return null;
      });
      const allTooltipLabels = tooltipLabelActive.concat(tooltipLabelInactive).filter(t => t !== null);

      // divido l'array che contiene tutte le labels in sotto-array da due elementi max chiamando il metodo arrayChunks
      const tooltipLabelsToShow = arrayChunks(allTooltipLabels, 2);

      const tooltipContent = tooltipLabelsToShow.map((t, index) => {
        return (
          <div key={`tooltipContent_${index}`}>
            <div className="tooltipLabelsContainer">
              {t}
            </div>
          </div>
        );
      });

      return (
        <Tooltip 
          color={"rgb(0, 80, 117)"}
          key={`tooltipTool_${keyIdx}`} overlayClassName='tooltipTools' placement="top"
          title= {tooltipContent}
        >
          <div className="divTools">
            <div className="badgeTools active" />
            <span className="labelActiveService">{el}</span>
          </div>
        </Tooltip>
      );
    });
    let counter = 0;
    if (maxLength > 0) {
      let serviceLogo = "";
      let serviceLabel = "";
      let appName = "";
      badges.push(turnedOffToolsUnique?.map((x,index) => {
        if (x === "TS Pay"){
          serviceLogo = ImgTSPay;
          serviceLabel = "Puoi importare automaticamente i movimenti bancari nel gestionale e riconciliarli con le operazioni contabili.";
          appName="accounting/details";
        } else if (x === "Incassa Subito"){
          serviceLogo = ImgIncassaSubito;
          serviceLabel = "Velocizza l’incasso delle tue fatture non scadute, senza costi fissi o canoni mensili. Scegli quali fatture cedere attraverso un processo semplice e senza burocrazia.";
          appName = "invoicetrading/details";
        } else if (x === "Check Up Impresa"){
          serviceLogo = ImgCheckupImpresa;
          serviceLabel= "La soluzione per monitorare costantemente l’equilibrio economico-finanziario delle aziende, visualizzare l’andamento del business, condividere gli indicatori di crisi.";
          appName = "creditrisk/details";
        } else if (x === "Digital Invoice"){
          serviceLogo = ImgDigitalInvoice;
          serviceLabel = "Puoi facilmente gestire l’intero flusso delle fatture elettroniche, sia verso i privati che verso la PA.";
          appName="fatturazione/details";
        }

        if (counter === maxLength || counter > maxLength) return null;
        counter++;
        return (
          <Tooltip 
            color={"rgb(0, 80, 117)"}
            key={index} overlayClassName='tooltipToolsCard' placement="top"
            title={<div style={{margin: "15px 10px 10px 10px"}} >
              <div style={{marginBottom:"10px", textAlign:"center"}}><img src={serviceLogo} alt="ts pay" /></div>
              <div className="labelActiveService tooltip" style={{height:"75px", width:"270px"}}>{serviceLabel}</div>
              <div style={{textAlign:"right"}}><a href={
                TSDIGITAL_PORTALE_PUBLIC_URL +
                                                                "#/" +
                                                                main.accountantIdSelected +
                                                                "/apps/" + appName
              }
              id="goToTSDigital"
              target="_blank"
              rel="noopener noreferrer"><Button kind='secondary'>Scopri di più</Button></a></div>
            </div>}>

            <div key={x} className="divTools">
              <div className="badgeTools off" />
              <span className="labelActiveService">{x}</span>
            </div>
          </Tooltip>
        );
      }));
    }
    return badges;
  };

  const orderPriority = (turnedOffServicesFiltered) => {
    let orderBy = ["Digital Invoice", "TS Pay", "Incassa Subito", "Check Up Impresa" ];
    let list = {};
    list[999] = [];
    for (let count= 0; count < turnedOffServicesFiltered?.length; count++){
      if (turnedOffServicesFiltered[count].appDescription === "Digital Bank Link"){
        turnedOffServicesFiltered[count].appDescription = "TS Pay";
      }
      let indexTool = orderBy.indexOf(turnedOffServicesFiltered[count].appDescription);
      if (!list[indexTool] && indexTool !== -1){
        list[indexTool] = [];
      }
      if (indexTool !== -1) {
        list[indexTool].push(turnedOffServicesFiltered[count]);
      } else {
        list[999].push(turnedOffServicesFiltered[count]);
      }
    }
    return list;
  };

  const renderTools = () => {
    let allCompanyServicesFilterd = [];
    let turnedOffServices = services?.allTsDigitalServices?.list;
    let excludeService = ["DBX", "EBS"];
    let turnedOffServicesFiltered = turnedOffServices?.filter((el) => !excludeService.includes(el.packageId));
    let activeService = {};
    if (
      !services?.allCompanyServices.status.started &&
      services?.allCompanyServices.status.ended &&
      services?.allCompanyServices?.status?.list
    ) {
      allCompanyServicesFilterd = services?.allCompanyServices.status.list.filter((el) => !excludeService.includes(el.packageId));
    }

    // TUTTI I SERVIZI RAGGRUPPATI PER APPID
    let allServicesOrdered = orderPriority(turnedOffServicesFiltered);
    // CICLO PER GRUPPO E SU OGNUNO VEDO SE IL SERVIZIO SINGOLO SI TROVA IN COMPANYSERVICES
    for (let group in allServicesOrdered){
      for (let index in allServicesOrdered[group]){
        for (let service in allCompanyServicesFilterd){
          let fatherName = allCompanyServicesFilterd[service].appDescription;
          if (fatherName === "Digital Bank Link"){
            fatherName = "TS Pay";
          }
          if (!Object.keys(activeService).includes(fatherName)) {
            activeService[fatherName] = [];
          }
          if (allCompanyServicesFilterd[service].id === allServicesOrdered[group][index].id){
            activeService[fatherName].push(allCompanyServicesFilterd[service].description);
          }
        }
      }
    }
    // Questo mi serve per avere, per ogni servizio padre, la lista di tutti i servizi(attivi e non attivi)
    let allServiceGroup = {};
    let all = {};
    for (let item in allServicesOrdered){
      allServiceGroup = allServicesOrdered[item].filter(({appDescription}) => Object.keys(activeService).includes(appDescription));
      for (let service in allServiceGroup){
        if (allServiceGroup[service].appDescription === "Digital Bank Link"){
          allServiceGroup[service].appDescription = "TS Pay";
        }
        if (!Object.keys(all).includes(allServiceGroup[service].appDescription)) {
          all[allServiceGroup[service].appDescription] = [];
        }
        all[allServiceGroup[service].appDescription].push(allServiceGroup[service].description);
      }
    }
    let turnedOffServicesFilteredOrdered = orderPriority(turnedOffServicesFiltered);
    let servicesListCanBeActivated = [];
    let servicesTotal = [];

    for (let item in turnedOffServicesFilteredOrdered){
      let toolGroup = turnedOffServicesFilteredOrdered[item];
      let activeServicesId = Object.keys(activeService);
      servicesListCanBeActivated = toolGroup?.filter(({ appDescription }) => !activeServicesId.includes(appDescription));
      servicesTotal = [...servicesTotal, ...servicesListCanBeActivated];
    }
    return renderServices(
      activeService,
      all,
      servicesTotal?.map(el => el.appDescription)
    );
  };

  return (
    <WidgetCard
      isCentered={false}
      titleWidget={null}
      type={"widgetTools"}
      footer={renderFooter()}
    >
      <p className="titleWidgetCreditsAndRevenues empty customizedForTools">
        <FormattedMessage id="widgetTools.tools" />
      </p>
      <div className="bodyTools">{renderTools()}</div>
    </WidgetCard>
  );
};

export default WidgetTools;
